import util from '../../../util';
import {DialogUtil} from '../../../util/dialog-util';
import FirstPickupApi from '../../../api/modules/FirstPickupApi';

const saveFirstPickup = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`/firstPickup/save`, payload.pickup, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el recojos.')
        reject(error.response)
      }
      reject()
    });
  })
}

/**
 * Guarda múltiples solicitudes agrupadas
 */
const saveBatchFirstPickup = ({ commit }, { context, pickups }) => {
  return FirstPickupApi.saveBatchPickups(context, pickups)
    .then((response) => response)
    .catch((error) => {
      console.error('Error en saveBatchFirstPickup:', error);
      DialogUtil.error(
        context,
        'Ocurrió un error al registrar las solicitudes de recojo.'
      );
      throw error;
    });
};

const listFirstPickup = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/firstPickup/${payload.idClient}`, {headers}).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los recojos.')
      reject(error)
    })
  })
}

const listStockInRange = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/stockInRange/${payload.idRangeBox}`, {headers}).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar el stock de cajas.')
      reject(error)
    })
  })
}


export default {
  saveFirstPickup,
  saveBatchFirstPickup,
  listFirstPickup,
  listStockInRange
}



// WEBPACK FOOTER //
// ./src/store/modules/firstPickup/actions.js